import React, { PropsWithChildren } from "react";
import { h1 } from "./commonStyles/Fonts";

interface ArticleTitleProps {
    as?: keyof JSX.IntrinsicElements;
}

const ArticleTitle: React.FC<PropsWithChildren<ArticleTitleProps>> = ({
    children,
    as = "h1",
}) => {
    const Element = as;

    return (
        <Element itemProp="headline" className={h1()}>
            {children}
        </Element>
    );
};

export default ArticleTitle;